var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowListPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.707 13.207a1 1 0 01-1.414 0l-4.5-4.5a1 1 0 010-1.414l4.5-4.5a1 1 0 011.414 1.414L6.914 8l3.793 3.793a1 1 0 010 1.414z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjcwNzEgMTMuMjA3MWMtLjM5MDUuMzkwNS0xLjAyMzY4LjM5MDUtMS40MTQyMSAwbC00LjUtNC40OTk5OWMtLjM5MDUyLS4zOTA1My0uMzkwNTItMS4wMjM2OSAwLTEuNDE0MjJsNC41LTQuNWMuMzkwNTMtLjM5MDUyIDEuMDIzNzEtLjM5MDUyIDEuNDE0MjEgMCAuMzkwNS4zOTA1My4zOTA1IDEuMDIzNjkgMCAxLjQxNDIyTDYuOTE0MjEgOGwzLjc5Mjg5IDMuNzkyOWMuMzkwNS4zOTA1LjM5MDUgMS4wMjM3IDAgMS40MTQyeiIvPgo8L3N2Zz4K";
export { SvgArrowListPrevious as ReactComponent };